<template>
    <div class="landing-page-desktop">
        <div>
            <div class="custom-toolbar">
                <div class="toolbar-left">
                    <img :src="pia_logo_white" alt="Logo" class="pia-logo" />

                    <v-avatar size="80" v-if="profileLoaded">
                        <v-img :src="userProfile?.profileImage" alt="User Avatar" />
                    </v-avatar>
                    <v-avatar size="120" v-else>
                        <v-img :src="Avatar_3D" alt="User Avatar" />
                    </v-avatar>

                    <h2>Hi, {{ tokenProfile?.name }}</h2>
                    <p class="today-date">{{ moment(date).format('ddd, DD MMMM YYYY') }}</p>
                </div>

                <div class="toolbar-right">
                    <v-icon class="logout-icon" @click="handleLogout">
                        mdi-logout
                    </v-icon>
                    <WeatherLocation class="mr-5" :weather-temp="parseFloat(weatherTemp)"
                        :weather-humidity="weatherHumidity" :city="weatherLocation" :weather-wind="weatherWind"
                        :weather-rain="weatherRain" :current-time="currentTime" />
                </div>
            </div>

            <LandingPageWorkLocation />

            <LandingPageFunctions />
        </div>

        <div class="footer-container">
            <p class="footer-text">{{ $t('landing-page.pinestack-rights') }}</p>
            <div class="footer-links">
                <a href="https://pinestack.io/en/contact/" class="footer-link" target="_blank">{{
                    $t('landing-page.contact-us') }}</a>
                <a href="https://pinestack.io/en/privacy-policy/" class="footer-link" target="_blank">{{
                    $t('landing-page.privacy-policy') }}</a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'
import oneVRDarkBackLogo from '@/oneVr/oneVrAssets/oneVRDarkBackLogo.png'
import moment from 'moment'
import WeatherLocation from './WeatherLocation.vue'
import LandingPageFunctions from './LandingPageFunctions.vue'
import LandingPageWorkLocation from './LandingPageWorkLocation.vue'
import { performLogout } from '@/controllers/BackboneAPI'
import pia_logo_white from '@/assets/Branding/Pia/pia_logo_white.png'
import { useI18n } from 'vue-i18n'
import Avatar_3D from '@/assets/General/Avatar_3D.png'
import { useOAuthService } from '@/services/OAuthService'

const props = defineProps({
    userProfile: { type: [Object, null], required: true, default: null },
    profileLoaded: { type: Boolean, required: true }
})

const weatherTemp = ref(0)
const weatherHumidity = ref(0)
const weatherWind = ref(0)
const weatherRain = ref(0)
const weatherLocation = ref('Munich')
const currentTime = ref(moment().format('HH:mm:ss'))
const date = ref(new Date())
const { locale, t } = useI18n()
const tokenProfile = ref(null)

const apiKey = '4ae793a3dd93a074ff16d7e97b06ec5b'
const city = 'Munich'

async function fetchWeather() {
    const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`)
    const data = await response.json()
    weatherTemp.value = data.main.temp.toFixed(1)
    weatherHumidity.value = data.main.humidity
    weatherWind.value = data.wind.speed
    weatherRain.value = data.rain ? data.rain['1h'] : 0
    weatherLocation.value = city
}

async function handleLogout() {
    await performLogout()
}

onMounted(async () => {
    try {
        await fetchWeather()
        tokenProfile.value = await useOAuthService().getUserProfile()
    } catch (error) {
        console.log('Error fetching weather data:', error)
    }
})

setInterval(() => {
    currentTime.value = moment().format('HH:mm:ss')
}, 1000)
</script>


<style scoped>
.landing-page-desktop {
    min-height: var(--app-viewport-height, 100vh);
    display: flex;
    flex-direction: column;
    padding-bottom: 70px;
}

.landing-page-desktop>div {
    flex: 1;
}

.custom-toolbar {
    background-image: url('@/assets/General/landingpage_desktop.png');
    background-size: cover;
    background-position: center;
    padding: 20px 20px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24rem;
    margin-bottom: -50px;
    /* important: so WorkLocation overlaps */
    position: relative;
}

.toolbar-left {
    color: #fff;
    display: flex;
    flex-direction: column;
    margin-left: 5rem;
}

.pia-logo {
    height: 40px;
    position: absolute;
    top: 10px;
    left: 15px;
}

.onevr-logo {
    font-size: 24px;
    cursor: pointer;
    color: white;
    position: absolute;
    top: 12px;
    right: 55px;
}

.today-date {
    font-size: 1rem;
    font-weight: bold;
    margin-top: 4px;
}

.toolbar-right {
    display: flex;
    padding: 20px;
}

.logout-icon {
    font-size: 24px;
    cursor: pointer;
    color: white;
    position: absolute;
    top: 20px;
    right: 11px;
}

.footer-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 28px;
    background-color: #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    font-size: 0.875rem;
    color: #718096;
    border-top: 1px solid #e0e0e0;
}

.footer-links {
    display: flex;
    gap: 20px;
}

.footer-link {
    color: #718096;
    text-decoration: none;
}

.footer-link:hover {
    text-decoration: underline;
}

@media (max-width: 992px) {
    .today-date {
        font-size: 1rem;
    }
}

@media (max-width: 850px) {
    .toolbar-left {
        margin-left: 2rem;

    }

    .today-date {
        font-size: 0.8+rem;
    }
}
</style>
